import { useState } from "react";
import styles from "./MapSideBar.module.css";

export default function Sidebar({
  activeMap,
  selectedZones,
  homeZone,
  setHomeZone,
  zoneCoverage,
  updateZoneCoverage
}) {

  const [name, setName] = useState("");

  const populateZones = async () => {
    try {
  
      const res = await fetch("http://localhost:3001/api/zone-reports/latest");
      const rows = await res.json();
  
      rows.forEach((row) => {
  
        updateZoneCoverage(row.zone_id, {
          peopleReached: row.number_reached || 0,
          percentCovered: row.percent || 0,
          notes: row.notes || ""
        });
  
      });
  
    } catch (err) {
      console.error("Populate failed:", err);
    }
  };

  const submitReports = async () => {
    try {
  
      const today = new Date().toISOString().split("T")[0];
  
      const requests = selectedZones.map((zone) => {
  
        const data = zoneCoverage[zone] || {};
  
        return fetch("http://localhost:3001/api/zone-report", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            zoneId: zone,
            percent: data.percentCovered || 0,
            notes: data.notes || "",
            volunteer: name,
            activityDate: today,
            numberReached: data.peopleReached || 0
          })
        });
  
      });
  
      await Promise.all(requests);
  
      console.log("Reports submitted");
  
    } catch (err) {
      console.error("Submit failed:", err);
    }
  };

  return (
    <div className={styles.sidebar}>

      {/* ========================= */}
      {/* CANVASS MODE */}
      {/* ========================= */}

      {activeMap === "canvass" && (
        <>
          <h1 className={styles.title}>Canvassing</h1>

          <div className={styles.section}>
            <input
              className={styles.input}
              placeholder="Volunteer Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className={styles.section}>
            <label className={styles.label}>Selected Regions</label>

            {selectedZones.length === 0 && (
              <div className={styles.empty}>Click regions on the map</div>
            )}

            {selectedZones.map((zone) => {

              const data = zoneCoverage[zone] || {};

              return (
                <div key={zone} className={styles.zoneBlock}>

                  <h3 className={styles.zoneTitle}>
                    {zone.replace("_", " ")}
                  </h3>

                  <input
                    className={styles.input}
                    type="number"
                    placeholder="People Reached"
                    value={data.peopleReached || ""}
                    onChange={(e) =>
                      updateZoneCoverage(zone, {
                        peopleReached: Number(e.target.value)
                      })
                    }
                  />

                  <input
                    className={styles.input}
                    type="number"
                    placeholder="Percent Covered"
                    value={data.percentCovered || ""}
                    onChange={(e) =>
                      updateZoneCoverage(zone, {
                        percentCovered: Number(e.target.value)
                      })
                    }
                  />

                  <textarea
                    className={styles.textarea}
                    placeholder="Notes"
                    value={data.notes || ""}
                    onChange={(e) =>
                      updateZoneCoverage(zone, {
                        notes: e.target.value
                      })
                    }
                  />

                </div>
              );
            })}
          </div>
        </>
      )}

      {/* ========================= */}
      {/* OTOWN MODE */}
      {/* ========================= */}

      {activeMap === "otown" && (
        <>
          <h1 className={styles.title}>Your Info</h1>

          <div className={styles.section}>
            <label className={styles.label}>Home Region</label>

            <select
              className={styles.select}
              value={homeZone || ""}
              onChange={(e) => setHomeZone(e.target.value)}
            >
              <option value="">Select Home Region</option>

              {selectedZones.map((zone) => (
                <option key={zone} value={zone}>
                  {zone.replace("_", " ")}
                </option>
              ))}
            </select>
          </div>

          <div className={styles.section}>
            <label className={styles.label}>Selected Regions</label>

            <div className={styles.tags}>
              {selectedZones.map((zone) => (
                <div key={zone} className={styles.tag}>
                  {zone.replace("_", " ")}
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* ========================= */}
      {/* SUBMIT */}
      {/* ========================= */}

      <div className={styles.buttonRow}>

      <button
        className={styles.populateButton}
        onClick={populateZones}
      >
        Populate
      </button>

      <button
        className={styles.submitButton}
        onClick={submitReports}
      >
        Submit
      </button>

      </div>
    </div>
  );
}